export const RESET_PASSWORD = /* GraphQL */ `
    mutation resetPassword(
        $email: String!
        $resetPasswordToken: String!
        $newPassword: String!
    ) {
        resetPassword(
            email: $email
            resetPasswordToken: $resetPasswordToken
            newPassword: $newPassword
        )
    }
`
